/* eslint-disable no-undef */
import {
	Box,
	HStack,
	Text,
	Button,
	Flex,
	useToast,
	Image,
  Input,
	Spacer
} from "@chakra-ui/react";
import {
	GiRoundBottomFlask,
} from "react-icons/gi";
import React, { useState, useEffect } from "react";
import { craftPotion, craftPotionWithModifier, getMinExperience, getRecipe } from "../../../util/web3/interactAlchemy";
import { directTokenAllowanceCheck, directTokenApproval, } from "../../../util/web3/interactBank";
import { levelCalculator, materialIconResolver, materialNameResolver } from "../../../util/helpers";
import { getRaiderExp } from "../../../util/web3/interactProfessions";
import { Raider } from "../../../types/raider";
import { EconomyTool } from "../../../pages/alchemy";
import { PotionDescriptor } from "../../../util/alchemyInfo";
import { ethers } from "ethers";

interface PotionProps {
  potion: PotionDescriptor;
  raider: Raider;
  tools: EconomyTool[];
  balances: Record<string, number>
  updateTools: () => Promise<void>;
}

interface Ingredients {
  readonly _contractAddress: string;
  readonly amount: number;
}

export const PotionDescription = (props: PotionProps) => {
	const [raiderExp, setRaiderExp] = useState<number>(0);
	const [quantity, setQuantity] = useState<number>(1);
	const [minExp, setMinExp] = useState<number>(0);
	const [recipe, setRecipe] = useState<Ingredients[]>([]);
	const toast = useToast();

	const can_use_modifier = (tool: EconomyTool) => {
		return quantity > 1 && tool.charges_left >= 1;
	}

	const craftingHandler = async (modifier?: EconomyTool) => {
		if(!levelCheck()) {
			throw "too low level"
		}
		if(!quantityCheck()) {
			throw "not enough materials"
		}

		// const approval = await areMaterialsApproved();
		let approvalsNeeded = false;


		const ingredientCalls = recipe.map(ingredient => directTokenAllowanceCheck(ingredient._contractAddress, process.env.NEXT_PUBLIC_CRAFTING_MASTER as string))
		const resultHash = [] as number[]
		await Promise.all(ingredientCalls).then((thing) => {
			thing.forEach(result => {
				resultHash.push(Number(result));

			})
		})
		console.log(resultHash)
		let ingredientIndex = 0;
		for (const ingredient of recipe) {
			const thisCost = ingredient.amount * quantity;		
			if (resultHash[ingredientIndex] < thisCost) {
				approvalsNeeded = true;
				await directTokenApproval(ingredient._contractAddress,process.env.NEXT_PUBLIC_CRAFTING_MASTER as string, toast)
			}
			ingredientIndex+= 1;
		}
		if (approvalsNeeded) {
			toast({
				title: "Approvals",
				description: `Please wait a moment for your approvals to clear`,
				status: "error",
				duration: 9000,
				position: "top",
				isClosable: true,
			});
			return false
		}

		if (modifier) {
			await craftPotionWithModifier(props.potion.address, modifier, quantity, parseInt(props.raider.id), toast);
			await props.updateTools();
		} else {
			await craftPotion(props.potion.address, quantity, parseInt(props.raider.id), toast);
		}
		
	};

	const levelCheck = () => {
		if (raiderExp < minExp) {
      toast({
				title: "Insufficient Level!",
				description: `This potion requires ${levelCalculator(
					minExp + 1
				)} Alchemy, but you are only level ${levelCalculator(
					raiderExp
				)}. Try an easier potion!`,
				status: "error",
				duration: 9000,
				position: "top",
				isClosable: true,
			});
			return false
		} else {
			return true;
		}
	};

	const quantityCheck = () => {
		recipe.forEach(ingredient => {
			const thisCost = ingredient.amount * quantity;
			const thisBalance = props.balances[ingredient._contractAddress] || 0
			if (thisCost > thisBalance) {

				toast({
					title: `Not enough ${materialNameResolver(ingredient._contractAddress)}!`,
					description: `You need more ${materialNameResolver(ingredient._contractAddress)} to make this many potions.`,
					status: "error",
					duration: 9000,
					position: "top",
					isClosable: true,
				});
				return false
			}
		})
		return true;
	}

	
	useEffect(() => {

		const fetchData = async () => {
			getRecipe(props.potion.address).then(resp => setRecipe(resp))
			
			
			getMinExperience(props.potion.address).then(resp => {
				setMinExp(Number(resp))
			})
			
			getRaiderExp(
				Number(props.raider.id),
				2
			).then(raiderXp => {
				if (raiderXp != undefined) {
					setRaiderExp(raiderXp);
				}
			})
			

		};

		fetchData();
	},[]);
	

	return (
		<Box
			position="relative"
			background="#4a556878"
			borderRadius="md"
			px={4}
			py={4}
		>
			<HStack spacing={4}>
				<Flex>
          <Box ml="5px">
						<Text fontWeight="bold" fontSize={20} maxW="xl" mb="4px">
							{props.potion.name}
						</Text>
						<Text fontWeight="400" fontSize={14} maxW="xl" mb="2">
							{props.potion.description}
						</Text>
					</Box>
					<Image 
            src={props.potion.icon}
            width="50px"
            height="50px"
            alt={props.potion.name}
			position="absolute"
			right="15px"
			top="5px"
          />
				</Flex>
				</HStack>
					<Box my="10px">
						<Flex mb="5px">
							<Text fontWeight="bold">Level: </Text> <Text ml="4px">{levelCalculator(minExp+1)}</Text>
						</Flex>
						<Flex mb="5px">
							<Text fontWeight="bold">Ingredients</Text>
							<Spacer/>
							<Text fontWeight="bold">Owned</Text>
						</Flex>

						{ recipe.map(ingredient => {
							return (
								<Flex key={`${props.potion.name}-${ingredient._contractAddress}`} alignItems="center" mb="3px">
								<Image src={materialIconResolver(ingredient._contractAddress)} height="25px" width="25px" />
								<Text ml="5px"><b>{ingredient._contractAddress == process.env.NEXT_PUBLIC_AURUM ? (ingredient.amount * (quantity || 0)) / (10 ** 18) : ingredient.amount * (quantity || 0)}x</b> {materialNameResolver(ingredient._contractAddress)}</Text>
								<Spacer />
								<Text ml="10px" backgroundColor="#222" px="2px" borderRadius="5px">{ingredient._contractAddress === process.env.NEXT_PUBLIC_AURUM ? parseInt(ethers.utils.formatEther(props.balances[ingredient._contractAddress] || 0)) : (props.balances[ingredient._contractAddress] || 0)}</Text>
							</Flex>
							)
						})}
					

          </Box>
      <Flex mt="15px">
        <Input maxW="100px" defaultValue={1} onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setQuantity(parseInt(e.currentTarget.value));
          }}/>
        <Button
          rightIcon={<GiRoundBottomFlask />}
          colorScheme="blue"
          ml="5px"
          width="100%"
          onClick={() => craftingHandler()}
        >
          Craft Now
        </Button>
      </Flex>


       {props.tools.map(tool => {
		return (<Flex key={`mod${tool.id}_${props.potion.name}`} mt="15px">
		<Text width="135px;font-size:11px;padding-top:4px">
			{tool.multiplier}% Bonus
			Charges: { tool.charges_left}/{tool.weekly_charges}
		</Text>
		<Button
			rightIcon={<GiRoundBottomFlask />}
			colorScheme="blue"
			ml="5px"
			disabled={!can_use_modifier}
			title={`Token ID ${tool.id}`}
			width="100%"
			onClick={() => craftingHandler(tool)}
		>
			Craft with Tool {quantity > 1 && <span>
			&nbsp;(Extra: {Math.min(tool.charges_left, Math.floor((quantity * tool.multiplier) / 100))})
				</span>}
		</Button>
		</Flex>
		)})}

      
		</Box>
	);
};
